<template>
  <div class="chart-container w-100">
    <apexchart type="treemap" :height="chartHeight" :options="chartOptions" :series="series"/>
  </div>
</template>

<script>
export default {
  name: 'HeadcountFunctionTreemapChart',
  props: {
    chartSeries: {
      type: Array,
      required: true
    },
    chartHeight: {
      type: [Number, String],
      default: 400
    },
    companyPrimaryColor: {
      type: String,
      default: '#006859'
    }
  },
  computed: {
    sortedData() {
      const known = this.chartSeries.filter(item => item.function !== 'Unknown')
      const unknown = this.chartSeries.filter(item => item.function === 'Unknown')
      return [...known.sort((a, b) => b.headcount - a.headcount), ...unknown]
    },
    series() {
      return [{
        name: 'Headcount',
        data: this.sortedData.map(item => ({
          x: item.function,
          y: item.headcount
        }))
      }]
    },
    chartOptions() {
      return {
        chart: {
          type: 'treemap',
          toolbar: { show: false },
          fontFamily: 'Manrope, Arial, sans-serif'
        },
        legend: { show: false },
        colors: [this.companyPrimaryColor],       
        plotOptions: {
          treemap: {
            distributed: true,
            enableShades: true,
            shadeIntensity: 0.5
          }
        },
        dataLabels: {
          enabled: true,
          style: {
            fontFamily: 'Manrope',
            colors: ['#fff']
          },
          formatter: function(text) {
            return `${text}`;
          },
        },
        tooltip: {
          y: { formatter: val => `${val} employees` }
        }        
      }
    }
  }
}
</script>